import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalChiTietDangChoVay } from "./ModalChiTietDangChoVay";

export const BtnChiTietDangChoVay = ({ item, cuahang, macuahang }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <a onClick={handleShow} href={() => false} style={{ color: "#006266", textDecoration: "underline" }}>
                {item}
            </a>

            {show && (
                <ModalChiTietDangChoVay
                    show={show}
                    onHide={handleClose}
                    cuahang={cuahang}
                    macuahang={macuahang}
                />
            )}
        </>
    );
};
